<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav"/>
    <a-spin class="page-load" v-if="pageLoad"/>
    <div class="record-depot" v-else>
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name">
              <i class="com"></i>机构团体精选
            </span>
          </div>
        </div>
        <div class="result-count">
          <span>共<b>{{rowCount}}</b>个</span>
          <div class="sort">
            <span :class="sort.field === 'CNT' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : ''" @click="handleSortChange('CNT')">唱片数</span>
            <span :class="sort.field === 'NAME' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('NAME')">名称</span>
          </div>
        </div>
        <div class="company-list">
          <div v-for="(item,index) in recordList" :key="'recordList'+index" class="company-cell">
            <div class="index">{{index+1}}</div>
            <div class="pic">
              <router-link :to="'/company-detail/'+encodeURIComponent(item['@id'])">
                <img v-if="item.img" :src="item.img" alt="" />
                <div v-else-if="item.nameChs" 
                  :class="'base-pic-placeholder bg'+parseInt(Math.random()*6)">
                  {{item.nameChs.substring(0,1)}}
                </div>
              </router-link>
            </div>
            <div class="info">   <router-link :to="'/company-detail/'+encodeURIComponent(item['@id'])">
              <div class="name" v-if="item.nameChs">
             
                  {{item.nameChs}}
             
              </div>
              <div class="des" v-if="item.description">
               {{
                  Array.isArray(item.description)
                    ? item.description[0].substring(0,item.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                    :  item.description.substring(0,item.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                }}
              </div>
              <div class="mb-count" v-if="item.phonoAmt">{{item.phonoAmt}}唱片</div>
                 </router-link>
            </div>
            <div class="count-c" v-if="item.phonoAmt">
            <b>{{item.phonoAmt}}</b>唱片
          </div>
            <div class="act">
              <span :class="item.isFavorite?'fav cur':'fav'" @click="handleFav(index)"></span>
            </div>
          </div>
        </div>
        <div class="page-box">
          <a-pagination 
          :total="pagerCount" 
          :current="currentPage" 
          @change="onChange"  
          show-quick-jumper show-less-items />
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player"/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from '@/components/player';
import { orgSearch,collFav,ncollFav } from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player
  },
  data(){
    return {
      sc:false,
      pageLoad:false,
      loginHref:null,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      recordList:[],
      showAll:[true,true,false,false,false,false],
      filterKeys:[],
      isFav:false,
      sort: {
        field: "CNT",
        order: "desc"
      }
    }
  },
  mounted () {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href
    this.$nextTick(() => {
      this.query();
    });
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer()
    next();
  },
  methods:{
    initData () { // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() { // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      // 排序
      const {field, order } = this.sort;
      this.searchParams.sorts = {
        [field]: order === "asc" ? 1 : 0
      };
      // 页码
      this.searchParams.pager.pageth = this.currentPage;
      if(this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item,index)=>{
        const dict = item.dict;
        // 简单检索
        if(dict == 'keyword') {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if(dict.indexOf('Dict') != -1){
          this.searchParams.facet[dict.replace('Dict','').toUpperCase()] = item.text;
        }
      })
      
    },
    async query() { // 查询
      // 参数设置
      // this.pageLoad = true
      this.onParamsHandle();
      console.log({searchParams:this.searchParams})
      const res = await orgSearch(this.searchParams);
      if(res){
        this.pageLoad = false
      }
      const result = res.data;
      this.recordList = result.datas;
      // 总数
      this.rowCount = result.pager.rowCount;
      // 页码
      this.pagerCount = result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    onCountHnadle(key) { // 统计数量
      this[key+'Count'] = 0;
      this[key+'Dict'].forEach((item, index)=>{
        this[key+'Count'] += item.count;
      })
    },
    schandleCancel(){
      this.sc = false
    },
   async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite ? await ncollFav({ uri: this.recordList[index]["@id"] }) : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.$refs.player.saveFav(this.recordList[index]);
      
      this.$refs.Nav.cpnclick(this.recordList[index].isFavorite);
    },
    handleSortChange(field) {
      if (field === this.sort.field) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.field = field;
        this.sort.order = field === "CNT" ? "desc" : "asc";
      }
      this.query(false);
    },
    onChange (current) { // 页码点击
      this.currentPage = current;
      this.query(false);
    },
  }
}
</script>

<style lang="less" scoped>

</style>